import React from 'react';
import { ImageGenerationDashboard } from '../components/ImageGenerationDashboard';

const ImageGenerationPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <ImageGenerationDashboard />
    </div>
  );
};

export default ImageGenerationPage;